import {CreateReducer} from '../utils/create_reducer';
import {SET_INSPECTION_LIST_FILTER} from "../actions/filter_actions";

const initState = {
    status:undefined,
    startDate:undefined,
    endDate:undefined,
    inspectionIds:undefined
};

const filterReducer = CreateReducer(initState, {
    [SET_INSPECTION_LIST_FILTER](state,action){
        return {...state,status:action.payload.status,startDate:action.payload.startDate,endDate:action.payload.endDate,inspectionIds:action.payload.inspectionIds }
    }
});

export default filterReducer;


// WEBPACK FOOTER //
// ./src/reducers/filter_reducer.js